import styled, { keyframes } from "styled-components";
import { FADE_DURATION_S } from "constants/pregnancyRevealReport";

const fadeDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledStepTitleBox = styled.div<{
  $delay: number;
  $safeAreaTop?: number;
}>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 56px 20px 32px 24px;
  opacity: 0;
  animation: ${fadeDown} ${FADE_DURATION_S}s ease-out both;
  animation-delay: ${({ $delay }) => $delay}s;
`;
